import { safeSplitMany } from "@/utils/fonts";

export async function splitTextSetup(container?: Element | HTMLElement) {
  const scope = container || document;
  const splitElements = scope.querySelectorAll("[data-split]");

  if (splitElements.length === 0) return;

  const elementsToSplit = Array.from(splitElements).map((element) => {
    const splitType = element.getAttribute("data-split") || "lines";
    const preserveWhitespace = element.hasAttribute("data-preserve-whitespace");
    const noMask = element.hasAttribute("data-no-mask");

    const splitOptions: any = {
      type: splitType,
      reduceWhiteSpace: !preserveWhitespace,
    };

    if (!noMask) {
      if (splitType === "lines") {
        splitOptions.linesClass = "line";
        splitOptions.mask = "lines";
      } else if (splitType === "words") {
        splitOptions.wordsClass = "word";
        splitOptions.mask = "words";
      } else if (splitType === "chars") {
        splitOptions.charsClass = "char";
        splitOptions.mask = "chars";
      }
    } else {
      if (splitType === "lines") {
        splitOptions.linesClass = "line";
      } else if (splitType === "words") {
        splitOptions.wordsClass = "word";
      } else if (splitType === "chars") {
        splitOptions.charsClass = "char";
      }
    }

    return { element, options: splitOptions };
  });

  try {
    await safeSplitMany(elementsToSplit);

    // Make elements visible after splitting
    splitElements.forEach((element) => {
      (element as HTMLElement).style.visibility = "visible";
    });
  } catch (error) {
    console.warn("SplitText setup failed:", error);
  }
}
